<template>
    <div class="relative min-h-screen md:flex">
        <Nav></Nav>
        <div class="flex-1 p-4 md:p-10">
            <!-- Page Heading -->
            <header class="bg-white shadow flex items-center justify-between" v-if="$slots.header">
                <div class="w-full py-6 px-4">
                    <slot name="header" />
                </div>
            </header>
            <div class="flex items-center bg-primary text-white text-sm font-bold mt-4 mb-4 px-4 py-3" v-if="$page.props.flash.message" role="alert">
                {{ $page.props.flash.message }}
            </div>
            <!-- Page Content -->
            <main>
                <slot />
            </main>
        </div>
    </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue'
import BreezeDropdown from '@/Components/Dropdown.vue'
import BreezeDropdownLink from '@/Components/DropdownLink.vue'
import BreezeNavLink from '@/Components/NavLink.vue'
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue'
import Nav from "@/Components/Admin/Nav";

export default {
    components: {
        Nav,
        BreezeApplicationLogo,
        BreezeDropdown,
        BreezeDropdownLink,
        BreezeNavLink,
        BreezeResponsiveNavLink,
    },

    data() {
        return {
            showingNavigationDropdown: false,
        }
    },
}
</script>
